import * as React from "react";
import { SponsoredContentSlotProps } from "components/flexComponents/SponsoredContentRenderer/slot/portal";

// The purpose of this component is to serve as a way to define slot placeholder
// consistently. Eg. to include same class names across all sponsored content slots.
const SponsoredContentSlot = ({ sci, classes = "" }: SponsoredContentSlotProps) => (
  <div className={`SimpleContainer SponsoredContentSlot ${classes}`} id={sci} />
);

export default SponsoredContentSlot;
